import { render, staticRenderFns } from "./fittings.vue?vue&type=template&id=55bc644d&scoped=true"
import script from "./fittings.vue?vue&type=script&lang=js"
export * from "./fittings.vue?vue&type=script&lang=js"
import style0 from "./fittings.vue?vue&type=style&index=0&id=55bc644d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc644d",
  null
  
)

export default component.exports